import React, { useEffect, useState, useCallback, useRef } from 'react';
// Tailwind CSS is assumed to be available in the environment.
// Font Awesome icons are used via a simulated class approach.

// --- PWA OFFLINE SYNC HELPER FUNCTIONS (Using localStorage) ---

/**
 * Retrieves the current queue of offline submissions from local storage.
 */  
import VolunteerPanel from './VolunteerPanel.tsx';
import UserPanel from './Userpannel.tsx';
import AdminPanel from './AdminPannel.tsx';
import { Button } from './ButtonWasty';
import AuthScreen from './AuthScreen.tsx';






const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline) {
    return (
      <div className="absolute top-0 left-0 right-0 z-50 bg-yellow-600 text-white text-center p-2 font-medium shadow-2xl">
        ⚠️ You are **Offline**. Data is saved locally and will sync when connection returns.
      </div>
    );
  }
  return null;
}

const Header = ({ userType, onLogout }) => (
  <header className="bg-gray-900 text-white p-4 shadow-2xl flex justify-between items-center relative z-10">
    <OfflineIndicator />
    <h1 className="text-3xl font-black tracking-tight">
      {userType === 'admin' && 'Admin Control Center'}
      {userType === 'volunteer' && 'Volunteer Field Portal'}
      {userType === 'user' && 'Shop Owner Dashboard'}
    </h1>
    <div className="flex items-center space-x-4">
      <span className="text-sm font-light hidden sm:inline">Role: <span className="capitalize font-semibold">{userType}</span></span>
      <Button
        onClick={onLogout}
        className="text-sm"
        variant="danger"
      >
        Logout
      </Button>
    </div>
  </header>
);

const Footer = () => (
  <footer className="bg-gray-900 text-gray-400 p-4 text-center mt-auto shadow-inner text-sm">
    <p>&copy; 2025 GNUFox. Pvt. Ltd</p>
  </footer>
);


// --- MAIN DASHBOARD COMPONENT ---
const WastyAdmin = () => {
  // Simulating authentication state and steps
  const [userType, setUserType] = useState(null); // 'admin', 'volunteer', 'user'
  const [authStep, setAuthStep] = useState('role-select'); // 'role-select', 'user-signup', 'user-login'
  const [currentUser, setCurrentUser] = useState(null);

  const handleAuthSuccess = (type) => {
    setUserType(type);
    setAuthStep('dashboard');
  }
  const handleLogout = () => {
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("userType");
    setUserType(null);
    setAuthStep('role-select');
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("loggedInUser");
    const storedUserType = localStorage.getItem("userType");

    if (storedUser && storedUserType === "user") {
      const parsedUser = JSON.parse(storedUser);
      setCurrentUser(parsedUser);
      setUserType("user");
      setAuthStep("dashboard");
    }
  }, []);

  // Determine which UI to show
  let content = null;

  if (authStep === 'user-signup') {
    content = <AuthScreen currentUser={currentUser} setCurrentUser={setCurrentUser} volunterlogin={false} isSignUp={true} onAuthSuccess={handleAuthSuccess} onSwitchScreen={setAuthStep} />;
  } else if (authStep === 'user-login') {
    content = <AuthScreen currentUser={currentUser} setCurrentUser={setCurrentUser} volunterlogin={false} isSignUp={false} onAuthSuccess={handleAuthSuccess} onSwitchScreen={setAuthStep} />;
  } else if (userType === 'admin') {
    content = <AdminPanel />;
  } else if (userType === 'volunteer') {
    content = <VolunteerPanel currentUser={currentUser} setCurrentUser={setCurrentUser} />;
  }
  else if (userType === 'volunteer-login') {
    content = <AuthScreen currentUser={currentUser} setCurrentUser={setCurrentUser} volunterlogin={true} isSignUp={false} onAuthSuccess={handleAuthSuccess} onSwitchScreen={setAuthStep} />;
  }
  else if (userType === 'user') {
    content = <UserPanel currentUser={currentUser} />;
  } else {
    // Default Role Selection Screen
    // Default Role Selection Screen (Enhanced UI)
content = (
  <div className="flex flex-col items-center justify-center w-full">
    {/* Header Section */}
    <div className="text-center mb-8">
      <h1 className="text-4xl font-extrabold text-gray-800 mb-2 tracking-tight">
        Cuttack Municipal Corporation
      </h1>
      <p className="text-lg text-indigo-700 font-medium">
        Smart Waste Management Initiative ♻️
      </p>
    </div>

    {/* Banner Section */}
    <div className="w-full max-w-4xl mb-8 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
    <picture>
  {/* Show web-banner.png on screens ≥ 768px */}
  <source
    srcSet="/assets/web-banner.png"
    media="(min-width: 768px) "
  />
  {/* Default (mobile) image */}
  <img
    src="/assets/mobile-banner.png"
    alt="Balijatra Banner"
    className="w-full max-w-sm md:max-w-4xl mb-1 rounded-lg shadow-lg"
  />
</picture>
    </div>
 {/* Role Selection Cards */}
    <div className="flex flex-col md:flex-row gap-6 justify-center items-stretch w-full max-w-4xl">
      {/* ADMIN LOGIN */}
      <div className="flex-1 p-6 bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-2xl shadow-md hover:shadow-xl transition-transform hover:scale-[1.03] border border-indigo-200 text-center">
        <h3 className="font-bold text-indigo-800 text-xl mb-3">Admin</h3>
        <p className="text-sm text-gray-600 mb-4">
          Access reports and analytics dashboard
        </p>
        <Button onClick={() => handleAuthSuccess('admin')} className="w-full" variant="primary">
          <i className="fas fa-lock mr-2"></i> Admin Login
        </Button>
      </div>

      {/* VOLUNTEER LOGIN */}
      <div className="flex-1 p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-md hover:shadow-xl transition-transform hover:scale-[1.03] border border-green-200 text-center">
        <h3 className="font-bold text-green-800 text-xl mb-3">Volunteer</h3>
        <p className="text-sm text-gray-600 mb-4">
          Inspect and record shop cleanliness data
        </p>
        <Button onClick={() => setUserType('volunteer-login')} className="w-full" variant="success">
          <i className="fas fa-user-tag mr-2"></i> Volunteer Login
        </Button>
      </div>

      {/* SHOP OWNER LOGIN / SIGNUP */}
      <div className="flex-1 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl shadow-md hover:shadow-xl transition-transform hover:scale-[1.03] border border-blue-200 text-center">
        <h3 className="font-bold text-blue-800 text-xl mb-3">Shop Owner</h3>
        <p className="text-sm text-gray-600 mb-4">
          Register your shop & track inspection results
        </p>
        <Button onClick={() => setAuthStep('user-signup')} className="w-full" variant="primary">
          <i className="fas fa-store mr-2"></i> Sign Up
        </Button>
        <button
          onClick={() => setAuthStep('user-login')}
          className="text-sm mt-3 text-indigo-600 hover:underline font-medium block w-full"
        >
          Already have an account? Sign In
        </button>
      </div>
    </div>
    <br />
    {/* 🌿 About Section */}
    <div className="w-full max-w-4xl bg-white/70 backdrop-blur-sm rounded-2xl shadow-md border border-gray-200 p-8 mb-10">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
        About the Initiative
      </h2>
      <p className="text-gray-700 text-base leading-relaxed text-justify mb-4">
        This platform is built to make festivals and events greener, smarter, cleaner, and plaster-free.
        It helps monitor sanitation in real time, reward responsible vendors, and engage the public in
        the journey toward a Zero Waste Festival.
      </p>
      <p className="text-gray-700 text-base leading-relaxed text-justify mb-4">
        By combining data, technology, and community participation, we ensure that every waste
        management activity — from segregation to recycling — is tracked, scored, and celebrated.
      </p>

      <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 text-center">
        What We Do
      </h3>
      <ul className="list-disc list-inside text-gray-700 space-y-2 text-base">
        <li>Digitally monitor cleanliness and waste handling</li>
        <li>Promote zero-waste practices through friendly competition</li>
        <li>Provide real-time dashboards for public awareness</li>
        <li>Generate actionable insights for municipal planning</li>
      </ul>

      <p className="text-lg text-center font-medium text-indigo-700 mt-8">
        Our mission is simple — to make zero waste achievable and visible.
      </p>
    </div>

   

    {/* Footer Branding */}
    <p className="mt-10 text-gray-500 text-sm text-center">
      © 2025 CMC & GNUFox Pvt. Ltd — Empowering Smart Cities 🌍
    </p>
  </div>
);


  }

  // Render the full application wrapper
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 font-sans">
      {userType && <Header userType={userType} onLogout={handleLogout} />}

      <main className={`flex-grow p-6 lg:p-10 flex ${!userType ? 'items-center justify-center' : ''}`}>
        {content}
      </main>

      <Footer />
    </div>
  );
};




export default WastyAdmin;











